import { jsx, jsxs } from 'react/jsx-runtime';
import { useNavigate } from 'react-router-dom';

/**
 * Clean 404 Not Found page inspired by TailGrids
 * Displays within the app layout when user is authenticated
 */
function NotFoundPage() {
    const navigate = useNavigate();
    const handleGoHome = () => {
        navigate('/');
    };
    const handleGoBack = () => {
        navigate(-1);
    };
    return (jsx("section", { className: "bg-background py-20 lg:py-[120px]", children: jsx("div", { className: "container mx-auto", children: jsx("div", { className: "-mx-4 flex", children: jsx("div", { className: "w-full px-4", children: jsxs("div", { className: "mx-auto max-w-[400px] text-center", children: [jsx("h2", { className: "mb-2 text-[50px] font-bold leading-none sm:text-[80px] md:text-[100px]", children: "404" }), jsx("h4", { className: "mb-3 text-[22px] font-semibold leading-tight ", children: "Oops! That page can't be found" }), jsx("p", { className: "mb-8 text-lg text-muted-foreground", children: "The page you are looking for might have been deleted" }), jsxs("div", { className: "flex flex-col gap-3 sm:flex-row sm:justify-center", children: [jsx("button", { onClick: handleGoHome, className: "inline-block rounded-lg bg-primary px-8 py-3 text-center text-base font-semibold text-primary-foreground transition hover:bg-primary/90", children: "Go To Home" }), jsx("button", { onClick: handleGoBack, className: "inline-block rounded-lg border px-8 py-3 text-center text-base font-semibold transition hover:border-primary hover:bg-primary hover:text-primary-foreground", children: "Go Back" })] })] }) }) }) }) }));
}

export { NotFoundPage };
//# sourceMappingURL=NotFoundPage.js.map
